import React, { useState, useEffect, useMemo } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";
import MultiSelectEditor from "./MultiSelectEditor";
import dayjs from "dayjs";
import Dropzone from "react-dropzone"
import ReactApexChart from "react-apexcharts"
import ColumnSelector from "./ColumnSelector";
import { StorageImage } from '@aws-amplify/ui-react-storage';
import {jsPDF} from 'jspdf';
import 'jspdf-autotable';
import { Storage } from '@aws-amplify/storage'

ModuleRegistry.registerModules([AllCommunityModule]);

function normPhotosGrid(note) {
    const arr = Array.isArray(note?.photos) ? note.photos : [];
    return arr.map(p => ({ s3_key: p?.s3_key || p?.s3Key || p?.key || "", comment: p?.comment || "" }))
              .filter(p => p.s3_key);
}

async function safeGetGrid(key) {
    if (!key) return null;
    try { return await Storage.get(key); } catch {
        try { return await Storage.get(key, { level: "public" }); } catch { return null; }
    }
}
import {
    Alert,
    Badge,
    Col,
    Collapse,
    CardHeader,
    Card,
    CardImg,
    CardBody,
    CardTitle,
    CardText,
    Button,
    Container,
    Dropdown,
    ButtonDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Modal,
    ModalHeader,
    ModalFooter,
    ModalBody,
    Nav,
    NavItem,
    NavLink,
    Form,
    FormGroup,
    Label,
    Pagination,
    PaginationItem,
    PaginationLink,
    Row,
    Table,
    TabContent,
    TabPane,
    Input,
} from "reactstrap"

const PlantGrid = ({ tableData, areas, onCellEdit, onCellValueChanged,
                       plantColumnCatalog, addPlantToSpreadsheet, onUpdateArea,
                       currYear, setCurrYear,
                       deletePlant, unitmeasurement, showCompleted, setShowCompleted,
    harvestDate, setHarvestDate, harvestAmount, setHarvestAmount,
    deleteNote,
    harvestUnit, setHarvestUnit,
    timelineNotes, onCreateJournalEntry, onUpdateJournalEntry, username,
                   addHarvest, deleteHarvest}) => {


    const [notes, setNotes] = useState("");
    const [noteTags, setNoteTags] = useState("");
    const [noteDate, setNoteDate] = useState("");
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [noteError, setNoteError] = useState("");
    const [pendingPhotos, setPendingPhotos] = useState(null);
    const [photoUrlByKey, setPhotoUrlByKey] = useState({});
    const [lightboxUrl, setLightboxUrl] = useState(null);
    const [gridApi, setGridApi] = useState(null);
    const [printModalOpen, setPrintModalOpen] = useState(false);
    const [visibleColumns, setVisibleColumns] = useState([
        "species",
        "variety",
        "numPlants",
        "area",
        "season_rotation",
        "status"
    ]);
    const [notesModalOpen, setNotesModalOpen] = useState(false);
    const [harvestsModalOpen, setHarvestsModalOpen] = useState(false);
    const [selectedPlant, setSelectedPlant] = useState(null);
    const [expandedDetails, setExpandedDetails] = useState({});
    const [chartKey, setChartKey] = useState(0);
    const [harvestPlotOptions, setHarvestPlotOptions] = useState({})
    const [currHarvests, setCurrHarvests] = useState([]);
    const [selectedSeasons, setSelectedSeasons] = useState(["Spring", "Summer", "Fall", "Winter"]);
    const [actionsDropdownOpen, setActionsDropdownOpen] = useState(false);
    const [filterModalOpen, setFilterModalOpen] = useState(false);
    const [pendingFilters, setPendingFilters] = useState({ plant: "", area: "", status: "", season: "" });
    const [activeFilters, setActiveFilters] = useState({ plant: "", area: "", status: "", season: "" });

    const STATUS_OPTIONS = ["Purchased","Not Started","Seed Starting","Transplanting","Growing","Harvesting","Failed","Completed"];
    const SEASON_OPTIONS = ["Spring","Summer","Fall","Winter"];

    const plantOptions = useMemo(() =>
        [...new Set(tableData.map(p => p.species).filter(Boolean))].sort()
    , [tableData]);

    const hasActiveFilters = activeFilters.plant || activeFilters.area || activeFilters.status || activeFilters.season;

    const applyFilters = () => {
        setActiveFilters({ ...pendingFilters });
        setFilterModalOpen(false);
    };

    const clearFilters = () => {
        const empty = { plant: "", area: "", status: "", season: "" };
        setPendingFilters(empty);
        setActiveFilters(empty);
        setFilterModalOpen(false);
    };

    const openFilterModal = () => {
        setPendingFilters({ ...activeFilters });
        setFilterModalOpen(true);
    };

    const filteredData = useMemo(() => {
        let data = showCompleted
            ? tableData
            : tableData.filter(p => p.status !== "Completed" && p.status !== "Failed");
        if (activeFilters.plant)  data = data.filter(p => p.species === activeFilters.plant);
        if (activeFilters.area)   data = data.filter(p => p.area === activeFilters.area);
        if (activeFilters.status) data = data.filter(p => p.status === activeFilters.status);
        if (activeFilters.season) data = data.filter(p => p.season_rotation === activeFilters.season);
        return data;
    }, [tableData, showCompleted, activeFilters]);

    const toggleSeason = (season) => {
        setSelectedSeasons((prev) =>
            prev.includes(season) ? prev.filter((s) => s !== season) : [...prev, season]
        );
    };
    const openHarvestsModal = (plant) => {
        setSelectedPlant(plant);

        if (plant.harvests && plant.harvests.length > 0) {
            const ndata = [{ name: "Harvests", type: "bar", data: [] }];
            const newLabels = [];

            plant.harvests.forEach((element) => {
                ndata[0].data.push(element.amount);
                newLabels.push(element.date)
            });

            var harvestPlotOptions = {
                chart: {
                    stacked: false,
                    toolbar: {
                        show: false,
                    },
                },
                stroke: {
                    width: [2,0],
                    curve: "smooth",
                },
                colors: ["#99A88D"],
                fill: {
                    opacity: [0.85, 0.25, 1],
                    gradient: {
                        inverseColors: false,
                        shade: "light",
                        type: "vertical",
                        opacityFrom: 0.85,
                        opacityTo: 0.55,
                        stops: [0, 100, 100, 100],
                    },
                },
                markers: {
                    size: 0,
                },
                legend: {
                    offsetY: 11,
                },
                labels: newLabels,
                xaxis: {
                    type: "datetime",
                },
                yaxis: {
                    title: {
                        text: "",
                    },
                },
                tooltip: {
                    shared: true,
                    intersect: false
                },
                grid: {
                    borderColor: "#f1f1f1",
                },
            }

            setHarvestPlotOptions(harvestPlotOptions);
            setCurrHarvests(ndata);
            setChartKey((k) => k + 1);
        } else {
            setCurrHarvests([{ name: "Harvests", type: "bar", data: [] }]);
        }

        setHarvestsModalOpen(true);
    };


    function handlePrintFiltered() {
        if (!gridApi) return;

        // ✅ Get all currently displayed (visible) columns
        const displayedColumns = gridApi.getAllDisplayedColumns();

        // ✅ Filter out Details & Select (checkbox) columns
        const filteredColumns = displayedColumns.filter((col) => {
            const field = col.getColDef().field;
            return field && !["actions", "checkbox"].includes(field);
        });

        const headers = filteredColumns.map((col) => col.getColDef().headerName);
        const fields = filteredColumns.map((col) => col.getColDef().field);

        // ✅ Get filtered + sorted rows
        const filteredRows = [];
        gridApi.forEachNodeAfterFilterAndSort((node) => filteredRows.push(node.data));

        // ✅ Generate the PDF
        generatePdfFromData(filteredRows, headers, fields);
    }

    function generatePdfFromData(data, headers, fields) {
        const doc = new jsPDF("p", "pt", "letter");

        // ✅ Utility to remove icons, emojis, and trim whitespace
        const cleanText = (text) => {
            if (text == null) return "";
            // Strip emojis, symbols, and leading/trailing spaces
            return String(text)
                .replace(/[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu, "")
                .replace(/[^\p{L}\p{N}\p{P}\p{Z}]/gu, "") // remove weird unicode symbols
                .trim();
        };

        // ✅ Build compact table rows based on visible column fields
        const rows = data.map((row) =>
            fields.map((field) => cleanText(row[field]))
        );

        // ✅ Logo (top right)
        const logoPath = `${window.location.origin}/static/media/logo-light.b05d979d3afd8520cecc.png`;
        const pageWidth = doc.internal.pageSize.getWidth();
        doc.addImage(logoPath, "PNG", pageWidth - 250, 10, 240, 40);

        // ✅ Title
        doc.setFontSize(14);
        doc.text("Plant Grid", 40, 40);

        // ✅ Compact styling for better fit
        doc.autoTable({
            head: [headers.map(cleanText)],
            body: rows,
            startY: 60,
            styles: {
                fontSize: 8,           // smaller text
                cellPadding: 2,        // tighter spacing
                lineWidth: 0.1,
                overflow: "linebreak", // wrap long text
            },
            headStyles: {
                fillColor: [160, 190, 150], // soft green
                fontStyle: "bold",
            },
            columnStyles: {
                0: { cellWidth: 80 }, // example — adjust if you need specific widths
            },
            margin: { left: 40, right: 40 },
        });

        doc.save("plantlist.pdf");
    }
    function handlePrintSeasonal() {
        const doc = new jsPDF("p", "pt", "letter");
        const pageWidth = doc.internal.pageSize.getWidth();

        // Logo and title
        const logoPath = `${window.location.origin}/static/media/logo-light.b05d979d3afd8520cecc.png`;
        doc.addImage(logoPath, "PNG", pageWidth - 250, 20, 240, 40);

        doc.setFontSize(16);
        doc.setFont("helvetica", "bold");
        doc.text("Seasonal Planting Plan", 40, 50);

        const seasonColors = {
            Spring: [200, 230, 200],
            Summer: [255, 210, 210],
            Fall: [255, 230, 200],
            Winter: [210, 230, 255],
        };

        const annuals = tableData.filter((p) => p.season?.toLowerCase() === "annual");
        const seasons = ["Spring", "Summer", "Fall", "Winter"];

        const unitLabel = unitmeasurement === "imperial" ? "lb" : "kg";
        let currentY = 80;

        seasons.forEach((season, index) => {
            const seasonPlants = annuals
                .filter((p) => p.season_rotation?.toLowerCase() === season.toLowerCase())
                .sort((a, b) => a.seedStartDate.localeCompare(b.seedStartDate));

            if (seasonPlants.length === 0) return;

            // Section header
            doc.setFontSize(14);
            doc.setTextColor(60, 60, 60);
            doc.text(`${season} Plantings`, 40, currentY);
            currentY += 10;

            // Table headers
            const headers = [
                "Species",
                "Variety",
                "# of Plants",
                "Area",
                "Seed Start Date",
                "Days to Harvest",
                `Estimated Harvest (${unitLabel})`,
            ];

            // Table rows
            const rows = seasonPlants.map((p) => [
                p.species || "",
                p.variety || "",
                p.numPlants || "",
                p.area || "",
                p.seedStartDate || "",
                p.daysToHarvest || "",
                typeof p.estHarvest === "number"
                    ? parseFloat(p.estHarvest).toFixed(2)
                    : "Not Applicable",
            ]);

            doc.autoTable({
                head: [headers],
                body: rows,
                startY: currentY + 10,
                styles: { fontSize: 8, cellPadding: 2 },
                headStyles: {
                    fillColor: seasonColors[season],
                    textColor: [0, 0, 0],
                    fontStyle: "bold",
                },
                margin: { left: 40, right: 40 },
                didDrawPage: (data) => {
                    currentY = data.cursor.y + 30;
                },
            });
        });

        doc.save("Seasonal_Plan.pdf");
    }


    const openNotesModal = (plant) => {
        setSelectedPlant(plant);
        setNotesModalOpen(true);
    };

    function handleAcceptedFiles(files) {
        files.map(file =>
            Object.assign(file, {
                preview: URL.createObjectURL(file),
                formattedSize: formatBytes(file.size)
            })
        )

        setSelectedFiles(files)
    }

    function formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return "0 Bytes"
        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

        const i = Math.floor(Math.log(bytes) / Math.log(k))
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
    }


    const closeModals = () => {
        setHarvestsModalOpen(false);
        setNotesModalOpen(false);
        setSelectedPlant(null);
    };

    const onGridReady = (params) => {
        setGridApi(params.api);   // ✅ store the API for later
    };

    const buildColumnDefs = (areas, visibleColumns) => {
        const headerStyle = { backgroundColor: "#DDE5D7" };

        // First add checkbox column
        const checkboxCol = {
            headerName: "",
            checkboxSelection: true,
            headerCheckboxSelection: true,
            width: 50,
            pinned: "left",
            headerStyle,
        };

        // Then build the dynamic plant columns
        const dynamicCols = visibleColumns
            .map((field) => {
                const config = plantColumnCatalog[field];
                if (!config) return null;

                if (field === "area") {
                    return {
                        ...config,
                        field,
                        headerStyle,
                        cellEditorParams: { values: areas.map((a) => a.name) },
                    };
                }

                return { field, ...config, headerStyle };
            })
            .filter(Boolean);
        const buttonCols = {
            headerName: "Details",
            field: "actions",
            editable: false,
            headerStyle,
            cellRenderer: (params) => (
                <div style={{ display: "flex", gap: "0.4rem" }}>
                    <button
                        className="btn btn-sm"
                        style={{ backgroundColor: "#7F8F7B", borderColor: "#7F8F7B", color: "#fff" }}
                        onClick={() => openHarvestsModal(params.data)}
                    >
                        <i className="fas fa-shopping-basket" /> Harvests
                    </button>
                    <button
                        className="btn btn-sm"
                        style={{ backgroundColor: "#DDE5D7", borderColor: "#DDE5D7", color: "#212529" }}
                        onClick={() => openNotesModal(params.data)}
                    >
                        <i className="bx bx-note" /> Notes
                    </button>
                </div>
            ),
            minWidth: 150,
            maxWidth: 200,
            suppressSizeToFit: true,
        }

        return [checkboxCol, ...dynamicCols, buttonCols];
    };

    const effectiveUsername = username || (() => {
        try { return JSON.parse(localStorage.getItem("user") || "{}").user || ""; } catch { return ""; }
    })();

    // Resolve photo URLs for the selected plant's notes
    useEffect(() => {
        if (!selectedPlant) return;
        const plantNotes = Array.isArray(timelineNotes) ? timelineNotes.filter(n => n.plant_id === selectedPlant.id) : [];
        let cancelled = false;
        (async () => {
            const toFetch = [];
            for (const n of plantNotes) {
                for (const p of normPhotosGrid(n)) {
                    if (p.s3_key && !photoUrlByKey[p.s3_key]) toFetch.push(p.s3_key);
                }
            }
            if (!toFetch.length) return;
            const updates = {};
            for (const key of toFetch) {
                const url = await safeGetGrid(key);
                if (url) updates[key] = url;
            }
            if (!cancelled && Object.keys(updates).length) setPhotoUrlByKey(prev => ({ ...prev, ...updates }));
        })();
        return () => { cancelled = true; };
    }, [timelineNotes, selectedPlant]); // eslint-disable-line react-hooks/exhaustive-deps

    // Upload pending photos once the newly created note_id is known
    useEffect(() => {
        if (!pendingPhotos?.files?.length || !selectedPlant) return;
        const plantNotes = Array.isArray(timelineNotes) ? timelineNotes.filter(n => n.plant_id === selectedPlant.id) : [];
        const newNote = plantNotes.find(n =>
            n.date === pendingPhotos.dateKey &&
            (n.note_text || "") === (pendingPhotos.noteText || "") &&
            normPhotosGrid(n).length === 0
        );
        if (!newNote?.note_id) return;
        const { files, dateKey } = pendingPhotos;
        setPendingPhotos(null);
        (async () => {
            try {
                const uploaded = [];
                for (const file of files) {
                    const key = `${effectiveUsername}/journal/${dateKey}/${newNote.note_id}/${Date.now()}_${file.name}`;
                    await Storage.put(key, file, { contentType: file.type });
                    const url = await safeGetGrid(key);
                    if (url) setPhotoUrlByKey(prev => ({ ...prev, [key]: url }));
                    uploaded.push({ s3_key: key, comment: "" });
                }
                onUpdateJournalEntry({ username: effectiveUsername, note_id: newNote.note_id, date: dateKey, photos: uploaded });
            } catch (e) { console.error("Photo upload failed:", e); }
        })();
    }, [timelineNotes, pendingPhotos]); // eslint-disable-line react-hooks/exhaustive-deps

    function addPlantLogForPlant(plant) {
        const hasContent = noteDate || notes?.trim() || selectedFiles.length > 0;
        if (!hasContent) {
            setNoteError("Please add a note, date, or photo before saving.");
            return;
        }
        setNoteError("");

        const area = areas.find(a => a.plants?.some(p => p.id === plant.id));
        if (!area) return;

        const date = noteDate ? noteDate.slice(0, 10) : new Date().toISOString().slice(0, 10);
        const noteText = notes?.trim() || "";

        if (selectedFiles.length > 0) {
            setPendingPhotos({ files: selectedFiles, dateKey: date, noteText });
            setSelectedFiles([]);
        }

        setNoteDate("");
        setNotes("");

        onCreateJournalEntry({
            username: effectiveUsername,
            area_id: area.id,
            plant_id: plant.id,
            note_text: noteText,
            date,
            photos: [],
        });
    }

    function removePlantFromSpreadsheet() {
        if (!gridApi) return;

        const selectedRows = gridApi.getSelectedRows();
        if (selectedRows.length === 0) {
            alert("No plants selected!");
            return;
        }

        // Group plant IDs by area to avoid competing saves when multiple
        // plants from the same area are deleted at once
        const byArea = {};
        selectedRows.forEach((plant) => {
            // Resolve the owning area by plant id — area names repeat across years,
            // so matching by name alone can pick the wrong year's area.
            const area = areas.find((a) => a.plants?.some((p) => p.id === plant.id));
            if (!area) return;
            if (!byArea[area.id]) byArea[area.id] = { area, plantIds: new Set() };
            byArea[area.id].plantIds.add(plant.id);
        });

        // One onUpdateArea call per area — removes all selected plants in one save
        Object.values(byArea).forEach(({ area, plantIds }) => {
            const newArea = { ...area, plants: area.plants.filter((p) => !plantIds.has(p.id)) };
            onUpdateArea(newArea);
        });

        gridApi.deselectAll();
    }

    const defaultColDef = { flex: 1, resizable: true,
        autoHeaderHeight: true,
        wrapHeaderText: true,
        filter: false
    };

    return (
        <div>
            <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "0.5rem" }}>
                <button
                    className="btn btn-sm"
                    style={{ backgroundColor: "#fff", borderColor: "#d1d5db", color: "#212529" }}
                    onClick={() => setPrintModalOpen(true)}
                >
                    <i className="bx bx-printer" /> Print
                </button>
                <ColumnSelector
                    visibleColumns={visibleColumns}
                    setVisibleColumns={setVisibleColumns}
                    plantColumnCatalog={plantColumnCatalog}
                />
                <button
                    type="button"
                    className="btn btn-sm"
                    style={{ backgroundColor: "#fff", borderColor: "#d1d5db", color: "#212529" }}
                    onClick={openFilterModal}
                >
                    Filter by{hasActiveFilters ? " ●" : ""}
                </button>
                <button
                    type="button"
                    className="btn btn-sm btn-link"
                    style={{ color: "#212529", textDecoration: "underline", padding: "0.25rem 0.5rem" }}
                    onClick={() => setShowCompleted(v => !v)}
                >
                    {showCompleted ? "Hide Done" : "Show Done"}
                </button>
                <div style={{ marginLeft: "auto", display: "flex", gap: "0.5rem" }}>
                    <Button
                        size="sm"
                        style={{ backgroundColor: "#FF9900", borderColor: "#FF9900", color: "#fff" }}
                        onClick={() => addPlantToSpreadsheet()}
                    >
                        <i className="bx bx-plus" /> Add Plant
                    </Button>
                    <Button
                        size="sm"
                        style={{ backgroundColor: "#B93535", borderColor: "#B93535", color: "#fff" }}
                        onClick={() => removePlantFromSpreadsheet()}
                    >
                        <i className="bx bx-trash" /> Delete Plant(s)
                    </Button>
                </div>
            </div>


            <br/>
            <Row>
                <Col md={12}>
                    <div
                        className="ag-theme-alpine"
                        style={{
                            width: "100%",
                            maxWidth: "100%",   // ✅ prevents horizontal overflow
                            height: 600,
                            overflowX: "auto",  // ✅ allows graceful scroll if needed
                        }}
                    >
                        <AgGridReact
                            rowData={filteredData}
                            columnDefs={buildColumnDefs(areas, visibleColumns)}
                            rowSelection="multiple"
                            defaultColDef={defaultColDef}
                            stopEditingWhenCellsLoseFocus={true}
                            onCellValueChanged={onCellValueChanged}
                            components={{}}
                            singleClickEdit={true}
                            onGridReady={onGridReady}
                        />

                    </div>
                </Col>
            </Row>


            <Modal isOpen={harvestsModalOpen} toggle={closeModals} size="lg">
                <ModalHeader toggle={closeModals}>
                    Harvests for {selectedPlant?.species || selectedPlant?.variety || "Plant"}
                </ModalHeader>
                <ModalBody>
                    {selectedPlant && (
                        <>
                            {/* Chart */}
                            <ReactApexChart
                                key={chartKey}
                                options={harvestPlotOptions}
                                series={currHarvests}
                                type="line"
                                height="150"
                            />

                            {/* Harvest list */}
                            <Row className="fw-bold mt-3">
                                <Col md={4}>Date</Col>
                                <Col md={4}>Amount (ounces)</Col>
                            </Row>

                            {selectedPlant.harvests &&
                                selectedPlant.harvests.map((harvest, idx) => (
                                    <Row key={idx} className="align-items-center mt-2">
                                        <Col md={4}>{harvest.date}</Col>
                                        <Col md={4}>{harvest.amount}</Col>
                                        <Col md={2}>
                                            <Button
                                                onClick={() => deleteHarvest(harvest.date, selectedPlant)}
                                                style={{ backgroundColor: "#B93535", borderColor: "#B93535", color: "#fff" }}
                                                className="btn-sm"
                                            >
                                                <i className="bx bx-trash" />
                                            </Button>
                                        </Col>
                                    </Row>
                                ))}

                            {/* Add harvest */}
                            <Row className="mt-3">
                                <Col md={4}>
                                    <Input
                                        type="date"
                                        value={harvestDate}
                                        onChange={(e) => setHarvestDate(e.target.value)}
                                    />
                                </Col>
                                <Col md={4}>
                                    <Input
                                        type="number"
                                        value={harvestAmount}
                                        placeholder="Amount"
                                        onChange={(e) => setHarvestAmount(e.target.value)}
                                    />
                                </Col>
                                <Col>
                                    <Button style={{ backgroundColor: "#FF9900", borderColor: "#FF9900", color: "#fff" }} className="btn-sm"
                                            onClick={() => addHarvest(selectedPlant)}>
                                        Add Harvest
                                    </Button>
                                </Col>
                            </Row>
                        </>
                    )}
                </ModalBody>
            </Modal>

            {/* 🌿 Notes Modal */}
            <Modal isOpen={notesModalOpen} toggle={closeModals} size="lg">
                <ModalHeader toggle={closeModals}>
                    Notes for {selectedPlant?.species} {selectedPlant?.variety}
                </ModalHeader>

                <ModalBody style={{ maxHeight: "80vh", overflowY: "auto" }}>
                    {selectedPlant && (
                        <Card outline color="secondary" className="border">
                            <CardBody style={{ margin: "5px", padding: "2px", border: "2px" }}>

                                {(() => {
                                    const plantNotes = Array.isArray(timelineNotes)
                                        ? timelineNotes.filter(n => n.plant_id === selectedPlant.id)
                                        : [];
                                    const areaName = areas.find(a => a.plants?.some(p => p.id === selectedPlant.id))?.name || "";
                                    return plantNotes.length > 0 ? (
                                        plantNotes.map((note) => {
                                            const photos = normPhotosGrid(note);
                                            return (
                                                <Card key={note.note_id} style={{ backgroundColor: "#f4f7f3", marginBottom: 8 }}>
                                                    <CardHeader style={{ backgroundColor: "#f4f7f3", borderBottom: "none", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 12px" }}>
                                                        <div style={{ display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap" }}>
                                                            <span style={{ fontSize: 13, fontWeight: 600, color: "#4a6741" }}>{note.date}</span>
                                                            <span className="note-tag">📍 {areaName}</span>
                                                            <span className="note-tag">🌿 {selectedPlant.species || selectedPlant.name}</span>
                                                        </div>
                                                        <Button style={{ backgroundColor: "#B93535", borderColor: "#B93535", color: "#fff" }} size="sm" onClick={() => deleteNote(note.note_id)}>Delete</Button>
                                                    </CardHeader>
                                                    <CardBody style={{ backgroundColor: "#f4f7f3", padding: "8px 12px" }}>
                                                        {note.note_text && (
                                                            <div style={{ color: "rgba(0,0,0,0.75)", lineHeight: 1.5, marginBottom: photos.length ? 10 : 0 }}>
                                                                {note.note_text}
                                                            </div>
                                                        )}
                                                        {photos.length > 0 && (
                                                            <div>
                                                                <div style={{ fontSize: 12, color: "rgba(0,0,0,0.5)", marginBottom: 6 }}>Photos ({photos.length})</div>
                                                                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                                                                    {photos.map(p => {
                                                                        const url = photoUrlByKey[p.s3_key];
                                                                        return (
                                                                            <div key={p.s3_key} style={{ border: "1px solid rgba(0,0,0,0.06)", borderRadius: 10, padding: 6 }}>
                                                                                {url ? (
                                                                                    <img src={url} alt={p.comment || "photo"}
                                                                                        style={{ width: 80, height: 80, objectFit: "cover", borderRadius: 8, cursor: "pointer" }}
                                                                                        onClick={() => setLightboxUrl(url)}
                                                                                    />
                                                                                ) : (
                                                                                    <div style={{ width: 80, height: 80, display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(0,0,0,0.03)", borderRadius: 8, fontSize: 11, color: "rgba(0,0,0,0.5)" }}>Loading…</div>
                                                                                )}
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </CardBody>
                                                </Card>
                                            );
                                        })
                                    ) : (
                                        <p>No notes yet.</p>
                                    );
                                })()}

                                {/* ✏️ Add Note */}
                                <Row className="mt-3">
                                    <Col md={6}><b>Add Note</b></Col>
                                </Row>

                                <Row>
                                    <Col md={12}>
                                        <Dropzone
                                            style={{ width: "100%", height: "20%", border: "1px solid black" }}
                                            onDrop={acceptedFiles => {
                                                handleAcceptedFiles(acceptedFiles);
                                                setNoteError("");
                                            }}
                                        >
                                            {({ getRootProps, getInputProps }) => (
                                                <div className="dz-message needsclick" {...getRootProps()}>
                                                    <input {...getInputProps()} />
                                                    <h4>Click here to upload Photo</h4>
                                                </div>
                                            )}
                                        </Dropzone>
                                    </Col>
                                </Row>

                                {selectedFiles.length > 0 && (
                                    <Row className="mt-2">
                                        <Col md={12}>
                                            {selectedFiles.map((f, i) => (
                                                <Card key={i} className="mt-1 mb-0 shadow-none border">
                                                    <div className="p-2">
                                                        <Row className="align-items-center">
                                                            <Col className="col-auto">
                                                                <img
                                                                    height="80"
                                                                    className="avatar-sm rounded bg-light"
                                                                    alt={f.name}
                                                                    src={f.preview}
                                                                />
                                                            </Col>
                                                            <Col>
                                                                <div className="font-weight-bold">{f.name}</div>
                                                                <div><strong>{f.formattedSize}</strong></div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Card>
                                            ))}
                                        </Col>
                                    </Row>
                                )}

                                <Row className="mt-3">
                                    <Col md={3}><b>Area</b></Col>
                                    <Col md={9}>
                                        <span>{areas.find(a => a.plants?.some(p => p.id === selectedPlant?.id))?.name || ""}</span>
                                    </Col>
                                </Row>

                                <Row className="mt-2">
                                    <Col md={3}><b>Plant</b></Col>
                                    <Col md={9}>
                                        <span>{selectedPlant?.species || selectedPlant?.name || ""}</span>
                                    </Col>
                                </Row>

                                <Row className="mt-2">
                                    <Col md={3}><b>Date</b></Col>
                                    <Col md={9}>
                                        <Input
                                            type="date"
                                            value={noteDate}
                                            onChange={e => {
                                                setNoteDate(e.target.value);
                                                setNoteError("");
                                            }}
                                        />
                                    </Col>
                                </Row>

                                <Row className="mt-2">
                                    <Col md={3}><b>Notes</b></Col>
                                    <Col md={9}>
              <textarea
                  className="form-control"
                  value={notes}
                  onChange={e => {
                      setNotes(e.target.value);
                      setNoteError("");
                  }}
              />
                                    </Col>
                                </Row>

                                {noteError && (
                                    <Row className="mt-2">
                                        <Col md={12}>
                                            <div className="text-danger">
                                                {noteError}
                                            </div>
                                        </Col>
                                    </Row>
                                )}

                                <Row className="mt-3">
                                    <Col md={2}>
                                        <Button
                                            onClick={() => addPlantLogForPlant(selectedPlant)}
                                            style={{ backgroundColor: "#FF9900", borderColor: "#FF9900", color: "#fff" }}
                                            className="btn-sm"
                                        >
                                            Add <i className="bx bx-photo-album" />
                                        </Button>
                                    </Col>
                                </Row>

                            </CardBody>
                        </Card>
                    )}
                </ModalBody>

                <ModalFooter>
                    <button className="btn" style={{ backgroundColor: "#fff", borderColor: "#d1d5db", color: "#374151" }} onClick={closeModals}>
                        Close
                    </button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={filterModalOpen} toggle={() => setFilterModalOpen(false)} size="md">
                <ModalHeader toggle={() => setFilterModalOpen(false)}>Filter Plants</ModalHeader>
                <ModalBody>
                    <FormGroup>
                        <Label><b>Plant</b></Label>
                        <Input type="select" value={pendingFilters.plant} onChange={e => setPendingFilters(prev => ({ ...prev, plant: e.target.value }))}>
                            <option value="">— All —</option>
                            {plantOptions.map(p => <option key={p} value={p}>{p}</option>)}
                        </Input>
                    </FormGroup>

                    <FormGroup>
                        <Label><b>Area</b></Label>
                        <Input type="select" value={pendingFilters.area} onChange={e => setPendingFilters(prev => ({ ...prev, area: e.target.value }))}>
                            <option value="">— All —</option>
                            {areas.map(a => <option key={a.id} value={a.name}>{a.name}</option>)}
                        </Input>
                    </FormGroup>

                    <FormGroup>
                        <Label><b>Season</b></Label>
                        <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
                            {SEASON_OPTIONS.map(s => (
                                <button
                                    key={s}
                                    type="button"
                                    className="btn btn-sm"
                                    style={pendingFilters.season === s
                                        ? { backgroundColor: "#7F8F7B", borderColor: "#7F8F7B", color: "#fff" }
                                        : { backgroundColor: "#fff", borderColor: "#d1d5db", color: "#212529" }}
                                    onClick={() => setPendingFilters(prev => ({ ...prev, season: prev.season === s ? "" : s }))}
                                >
                                    {s}
                                </button>
                            ))}
                        </div>
                    </FormGroup>

                    <FormGroup>
                        <Label><b>Status</b></Label>
                        <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
                            {STATUS_OPTIONS.map(s => (
                                <button
                                    key={s}
                                    type="button"
                                    className="btn btn-sm"
                                    style={pendingFilters.status === s
                                        ? { backgroundColor: "#7F8F7B", borderColor: "#7F8F7B", color: "#fff" }
                                        : { backgroundColor: "#fff", borderColor: "#d1d5db", color: "#212529" }}
                                    onClick={() => setPendingFilters(prev => ({ ...prev, status: prev.status === s ? "" : s }))}
                                >
                                    {s}
                                </button>
                            ))}
                        </div>
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <button type="button" className="btn btn-sm" style={{ backgroundColor: "#FF9900", borderColor: "#FF9900", color: "#fff" }} onClick={applyFilters}>
                        Apply
                    </button>
                    <button type="button" className="btn btn-sm" style={{ backgroundColor: "#fff", borderColor: "#d1d5db", color: "#212529" }} onClick={() => setFilterModalOpen(false)}>
                        Cancel
                    </button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={printModalOpen} toggle={() => setPrintModalOpen(false)} size="md">
                <ModalHeader toggle={() => setPrintModalOpen(false)}>Print Options</ModalHeader>
                <ModalBody className="text-center">
                    <p style={{ marginBottom: "1rem" }}>Select what you’d like to print:</p>

                      <button
                            type="button"
                            className="btn btn-sm"
                            style={{ backgroundColor: "#7F8F7B", borderColor: "#7F8F7B", color: "#fff", width: "auto", minWidth: "120px" }}
                            onClick={handlePrintFiltered}
                        >
                            Print Table
                        </button>
                     &nbsp;


                        <button
                            type="button"
                            className="btn btn-sm"
                            style={{ backgroundColor: "#7F8F7B", borderColor: "#7F8F7B", color: "#fff", width: "auto", minWidth: "150px" }}
                            onClick={() => handlePrintSeasonal(selectedSeasons)}
                        >
                            Print Seasonal Plan
                        </button>
                </ModalBody>


                <ModalFooter>
                    <button className="btn" style={{ backgroundColor: "#fff", borderColor: "#d1d5db", color: "#374151" }} onClick={() => setPrintModalOpen(false)}>
                        Close
                    </button>
                </ModalFooter>
            </Modal>


        {lightboxUrl && (
            <div onClick={() => setLightboxUrl(null)}
                style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.85)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", cursor: "zoom-out" }}>
                <img src={lightboxUrl} alt="full size" style={{ maxWidth: "90vw", maxHeight: "90vh", borderRadius: 8 }} />
            </div>
        )}

        </div>

    );
};

export default PlantGrid;
